import query from 'query-string';

// Parse the query string
export const parsedQueryString = query.parse(location.search);

/**
 * Indicates whether screenshot mode is enabled
 */
export let screenshotModeEnabled;

// Check if we appear to be in the Drupal layout builder
if (document.getElementById('node-basic-page-layout-builder-form')) {
    // It looks like we're in the layout builder -
    // force screenshot mode, which will disable scroll
    // jacking
    screenshotModeEnabled = true;
} else {
    // Enable or disable screenshot mode based on the presence
    // of "screenshot-mode=true" in the parsed query string
    screenshotModeEnabled = parsedQueryString['screenshot-mode'] === 'true';
}

// If screenshot mode is enabled, add a class to the <body> element
if (screenshotModeEnabled) {
    document.body.classList.add('screenshot-mode');
}

/**
 * Caps floating-point values to limit the number of digits output
 * when converted to a string for CSS values
 * @param {number} value
 * @param {number} accuracy
 * @return {number}
 */
export function trimValue(value, accuracy = 1000) {
    return Math.round(value * accuracy) / accuracy;
}

/**
 * Parses JSON packed into an HTML attribute
 * @param {HTMLElement} element
 * @param {string} attributeName
 * @return {object}
 */
export function parseJsonAttribute(
    element,
    attributeName,
) {
    let jsonParameters = element.getAttribute(attributeName);
    if (jsonParameters) {
        jsonParameters = jsonParameters.trim();

        // Add enclosing brackets if not present
        let pattern = /^{.+}$/;
        if (!pattern.test(jsonParameters)) {
            jsonParameters = `{${jsonParameters}}`;
        }

        // Replace single quotes with double quotes, otherwise it's invalid JSON
        // and will cause an error
        pattern = /\'([^\']+)\'/;
        let match = pattern.exec(jsonParameters);
        while (match) {
            jsonParameters = jsonParameters.replace(`'${match[1]}'`, `"${match[1]}"`);
            match = pattern.exec(jsonParameters);
        }

        return JSON.parse(jsonParameters);
    } else {
        return {};
    }
}

/**
 * Returns an easing function for the given GSAP name
 * @param {string} value
 * @return {function}
 */
export function parseEasingFunctionParameter(value) {
    if (value) {
        // Parse GSAP easing name
        return gsap.parseEase(value);
    } else {
        // No easing
        return (value) => {
            return value;
        };
    }
}

/**
 * Converts an element into a <button>, copying over its
 * innerHTML and attributes and returning the new button,
 * if created
 * @param {Element} element
 * @return {Element}
 */
export function convertToButton(element) {
    if (element.tagName != 'BUTTON') {
        const button = document.createElement('button');
        button.innerHTML = element.innerHTML;

        for (const attribute of element.attributes) {
            button.setAttribute(attribute.name, attribute.value);
        }

        element.parentNode.insertBefore(button, element);
        element.remove();
        element = button;
    }

    return element;
}
